import React, { useState, useEffect } from 'react';
import style from './Switch.module.css';


const Switch = props => {
    return <main style={{ "--switchWidth": props.width ? props.width : "25vw", "--switchHeight": props.height ? props.height : "5vh" }} className={ [style.main, props.active && style.active, props.disabled && style.disabled].join(" ") } onClick={ () => !props.disabled && props.onChange() }>
        <div className={ [style.cursor, props.active && style.active].join(" ") }></div>
    </main>;
}

export default Switch;